require('./mortgageRequestAppraisalSetAccountStep2.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ components
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts.js');
const MortgageRequestAppraisalRequestCostWafer = require('components/mortgageRequest/mortgageRequestAppraisalRequest/mortgageRequestAppraisalRequestCostWafer/mortgageRequestAppraisalRequestCostWafer');

// @ constants
const { ACCOUNT_INTERVENTION_OWNER } = require('constants/index');
const { ACCOUNTS_CODES } = require('constants/mortgageRequestAppraisalRequest')
const { SECOND_STEP } = require('constants/index');
const { BLOCKED_ACCOUNTS_APPRAISAL } = require('constants/operationCodesAccounts');

//@commons
const { LoadingSection } = require('commonsComponents/loadingSection');

//@ helpers
const { formatText } = require('core/i18n').i18n;

class MortgageRequestAppraisalSetAccount extends React.Component {
    constructor(props) {
        super(props);

        this.handleAccountChange = this.handleAccountChange.bind(this);
    }

    componentWillMount() {
        const { getBlockedAccounts,
            immAccounts, immPayment,
            setTotalCost } = this.props;
        const totalCost = immPayment.get('appraisalCost');
        const accountsMap = immAccounts.get('byId');
        const accountsIndexes = this.getAccountsList(immAccounts.get('byOrder'), accountsMap);

        if (!immAccounts.get('blockedAccountsSuccess')) {
            const accounts = accountsIndexes.map(id => immAccounts.getIn(['byId', id]));
            getBlockedAccounts(accounts, BLOCKED_ACCOUNTS_APPRAISAL);
        }

        setTotalCost(totalCost);
    }

    componentWillUnmount() {
        const { resetBlockedAccounts } = this.props;

        resetBlockedAccounts();
    }

    getAccountsList(accounts, accountsMap) {
        return accounts.filter(accountId => {
            const accountHolder = accountsMap.getIn([accountId, 'interventionType']);
            const accountProduct = accountsMap.getIn([accountId, 'newProduct']);
            return accountHolder === ACCOUNT_INTERVENTION_OWNER && accountProduct === ACCOUNTS_CODES.CURRENT_ACCOUNT_CODE
        });
    }

    handleAccountChange(accountId) {
        const { immAccounts, setAccount } = this.props;
        if (!!accountId) {
            const immAccount = immAccounts.getIn(['byId', accountId]);
            setAccount(accountId, immAccount.getIn(['balance', 'amount']), immAccount.get('iban'));
        }
    }

    buildAccounts() {
        const { immAppraisalRequest, immAccounts } = this.props;
        const accountsMap = immAccounts.get('byId');
        const isBlockedAccountsLoading = immAccounts.get('blockedAccountsLoading');
        const accountsIndexes = this.getAccountsList(immAccounts.get('byOrder'), accountsMap);

        const immStep = immAppraisalRequest.getIn(['steps', SECOND_STEP]);
        const accountId = immStep.get('accountId');
        const accountRequiredAlertVisible = immStep.get('hasAccountError');
        const errorCode = immStep.get('accountErrorCode');

        const errorMessage = formatText(`mortgageRequestAppraisalRequest-appraiserSelectAccountError${errorCode}`);
        const label = formatText('mortgageRequestAppraisalRequest-appraiserAccountLabel');
        const title = formatText('mortgageRequestAppraisalRequest-appraiserAccountitle');
        const disclaimer = {
            warning: 'mortgageRequestAppraisalRequest-mortgageRequestAppraisalRequest_blockedAccountsWarning',
            important: 'mortgageRequestAppraisalRequest-mortgageRequestAppraisalRequest_blockedAccountsImportant'
        };

        return !immAccounts.get('blockedAccountsLoading') ? (
            <div className="mortgage-request-appraisal-request-set-account__wraper">
                <h1 className="mortgage-request-appraisal-request-set-account__title">{title}</h1>
                <DropdownAccounts
                    blockedAccountsAll={immAccounts.get('blockedAccountsAll')}
                    blockedAccountsIds={immAccounts.get('blockedAccountsIds')}
                    disclaimer={disclaimer}
                    label={label}
                    immAccounts={accountsMap}
                    currentAccountId={accountId}
                    accountsIndexes={accountsIndexes.toJS()}
                    onAccountChange={this.handleAccountChange}
                    error={accountRequiredAlertVisible}
                    errorMsg={errorMessage}
                    loading={isBlockedAccountsLoading}
                />
            </div>
        ) : <LoadingSection />;
    }

    render() {
        const { immPayment } = this.props;
        const accounts = this.buildAccounts();

        return (
            <div className="mortgage-request-appraisal-request-set-account ">
                {accounts}
                <MortgageRequestAppraisalRequestCostWafer
                    immPayment={immPayment}
                />
            </div>
        )
    }
}

MortgageRequestAppraisalSetAccount.propTypes = {
    getBlockedAccounts: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immAppraisalRequest: PropTypes.object.isRequired,
    immEstates: PropTypes.object.isRequired,
    immPayment: PropTypes.object.isRequired,
    resetBlockedAccounts: PropTypes.func.isRequired,
    setAccount: PropTypes.func.isRequired,
    setTotalCost: PropTypes.func.isRequired
};

module.exports = MortgageRequestAppraisalSetAccount
